import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { OrderService } from '../../Services/order.service';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-order-list-button',
  templateUrl: './order-list-button.component.html',
  styleUrls: ['./order-list-button.component.scss']
})
export class OrderListButtonComponent implements OnInit {

  router = inject(Router);
  orderService = inject(OrderService);
  count: number = 0;

  MyOrderList: WritableSignal<string> = signal('');
  private languageService = inject(LanguageService);
  language = this.languageService.getLanguage();

  ngOnInit(): void {
    // Retrieve previous count from sessionStorage, defaulting to 0 if it doesn't exist
    const storedCount = Number(sessionStorage.getItem('orderCount') || '0');
    this.count = storedCount;

    this.orderService.orders$.subscribe((orders) => {
      let newCount:number = 0;

      orders.forEach((order) => {
        if(order.amount > 0){
          newCount += order.amount;
        }
      });
      // Update the count and save it to sessionStorage
      this.count = newCount;
      sessionStorage.setItem('orderCount', this.count.toString());
    });

    this.updateTitles();

  }

  redirect(): void {
    this.router.navigate(['/orders']);
  }

  private updateTitles() {
    // Update titles based on the current language in the service
    this.MyOrderList = this.languageService.MyOrderList;
    this.language = this.languageService.getLanguage();
  }
}
